module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('vue-progress-bar'), _vm._v(" "), (!_vm.loggedIn) ? [_c('router-view')] : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? [_c('v-navigation-drawer', {
    staticClass: "blue lighten-5",
    attrs: {
      "width": "250",
      "light": "",
      "mini-variant": _vm.mini,
      "app": ""
    },
    on: {
      "update:miniVariant": function($event) {
        _vm.mini = $event
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    staticClass: "pa-0"
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-content', [_c('br'), _vm._v("\n            Credits: " + _vm._s(_vm.user.credit) + "\n\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-list-tile-action', {
    staticStyle: {
      "min-width": "30px"
    }
  }, [_c('v-menu', {
    attrs: {
      "bottom": "",
      "right": "",
      "offset-y": "",
      "origin": "bottom right",
      "transition": "v-slide-y-transition"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": "",
      "light": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', _vm._l((_vm.userMenus), function(item) {
    return _c('v-list-tile', {
      key: item.title,
      attrs: {
        "value": "true",
        "to": item.link,
        "router": ""
      }
    }, [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.title)
      }
    })], 1)
  }))], 1)], 1), _vm._v(" "), _c('v-list-tile-action', {
    staticStyle: {
      "min-width": "30px"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.mini = !_vm.mini
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.title,
      attrs: {
        "router": ""
      },
      on: {
        "click": function($event) {
          _vm.clickMenu(item)
        }
      }
    }, [_c('v-list-tile-action', {
      staticClass: "pr-1 pl-2 mr-1"
    }, [_c('v-icon', {
      class: _vm.activeMenuItem.includes(item.title) ? 'blue--text' : '',
      attrs: {
        "title": item.title,
        "light": ""
      },
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', {
      class: _vm.activeMenuItem.includes(item.title) ? 'blue--text' : ''
    }, [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.title)
      }
    })], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "app": ""
    }
  }, [_c('v-toolbar-side-icon', {
    attrs: {
      "light": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-content', [_c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "row": ""
    }
  }, [_c('router-view')], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-footer', {
    staticStyle: {
      "justify-content": "center",
      "text-align": "center"
    },
    attrs: {
      "inset": true,
      "app": ""
    }
  }, [_c('span', [_vm._v("© " + _vm._s(_vm.pagetitle) + " 2018")])])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1758e8ca","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 397
// module chunks = 1